import * as _ from 'lodash';
// tslint:disable-next-line:no-submodule-imports
import { all, call, Effect, put, putResolve, select } from 'redux-saga/effects';
import { Group, GroupCollection, Workspaces } from '../../clients/aasServerClient.generated';
import * as GroupRepository from '../../repositories/GroupRepository';
import { takeEveryWithErrorHandling } from '../sagas';
import { RootState } from '../store';
import { unselectAll} from '../tables/actionCreators';
import { storePagingState } from '../tables/actionCreators';
import { getFilters, getLimit, getPaging, getSearch, getSorting, getStart } from '../tables/selectors';
import { TableFilters, TablePaging, TableSorting } from '../tables/state';
import {
    fetchAllGroups as fetchAllGroupsCreator,
    fetchTableGroups as fetchGroupsCreator,
    savedSingleGroup,
    storeAllGroups,
    storeGroupsPerWorkspace,
    storeSingleGroup,
    storeTableGroups
} from './actionCreators';
import {
    ActionTypeNames, AssignGroupsWorkspacesAction,
    CopySingleGroupAction, CreateSingleGroupAction, FetchGroupsPerWorkspaceAction,
    DeleteGroupsAction, FetchSingleGroupAction,
    NewSingleGroupAction, SaveSingleGroupAction,
} from './actions';

function* fetchTableGroups() {
    const start: number = yield select(getStart, 'groups');
    const limit: number = yield select(getLimit, 'groups');
    const sorting: TableSorting = yield select(getSorting, 'groups');
    const filters: TableFilters = yield select(getFilters, 'groups');
    const paging: TablePaging = yield select(getPaging, 'groups');
    const search: string = yield select(getSearch, 'groups');

    const res: GroupCollection = yield call(
        GroupRepository.getGroups,
        limit, start, sorting, filters, search,
    );
    yield all([
        putResolve(storeTableGroups(res.items)),
        putResolve(storePagingState('groups', {
            numberOfItems: res.count || 0,
            numberOfPages: Math.ceil((res.count || 0) / paging.itemsPerPage)
        }))
    ]);
}


function* fetchTableGroupsWoFilters() {
    const start: number = yield select(getStart, 'groups');
    const limit: number = yield select(getLimit, 'groups');
    const sorting: TableSorting = yield select(getSorting, 'groups');
    
    const paging: TablePaging = yield select(getPaging, 'groups');
    const search: string = yield select(getSearch, 'groups');

    const res: GroupCollection = yield call(
        GroupRepository.getGroupsWoFilters,
        limit, start, sorting,  undefined,
    );
    yield all([
        putResolve(storeTableGroups(res.items)),
        putResolve(storePagingState('groups', {
            numberOfItems: res.count || 0,
            numberOfPages: Math.ceil((res.count || 0) / paging.itemsPerPage)
        }))
    ]);
}

export function* watchFetchTableGroups() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchTableGroups, fetchTableGroups);
}


export function* watchFetchTableGroupsNoSearch() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchTableGroupsNoSearch, fetchTableGroupsWoFilters);
}


function* fetchAllGroups() {
    const res: GroupCollection = yield call(GroupRepository.getAllGroups);
    yield putResolve(storeAllGroups(res.items));
}

function* fetchGroupsPerWorkspace(action: FetchGroupsPerWorkspaceAction) {
    const res: GroupCollection = yield call(GroupRepository.getGroupsPerWorkspace, action?.ids);
    yield putResolve(storeGroupsPerWorkspace(res.items));
}

export function* watchFetchAllGroups() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchAllGroups, fetchAllGroups);
}

export function* watchFetchGroupsPerWorkspace() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchGroupsPerWorkspace, fetchGroupsPerWorkspace);
}
function* fetchSingleGroup(action: FetchSingleGroupAction) {
    const group: Group = yield call(GroupRepository.getGroup, action.id);
    delete group.users;
    yield putResolve(storeSingleGroup(group));
}

function* watchFetchSingleGroup() {
    yield takeEveryWithErrorHandling(ActionTypeNames.FetchSingleGroup, fetchSingleGroup);
}

function* copySingleGroup(action: CopySingleGroupAction) {
    const res: Group = yield call(GroupRepository.getGroup, action.id);
    const group: Partial<Group> = {
        name: '',
        workspaces: res.workspaces,
    };
    yield putResolve(storeSingleGroup(group));
}

function* watchCopySingleGroup() {
    yield takeEveryWithErrorHandling(ActionTypeNames.CopySingleGroup, copySingleGroup);
}

function* newSingleGroup(action: NewSingleGroupAction) {
    const group: Partial<Group> = {
        name: '',
        workspaces: [new Workspaces({ id: '' })],
    };
    yield putResolve(storeSingleGroup(group));
}

function* watchNewSingleGroup() {
    yield takeEveryWithErrorHandling(ActionTypeNames.NewSingleGroup, newSingleGroup);
}

function* saveSingleGroup(action: SaveSingleGroupAction) {
    const res = yield call(
        GroupRepository.updateGroup,
        action.group, action.workspaces,
    );
    yield putResolve(savedSingleGroup());
    yield all([
        put(fetchGroupsCreator()),
        put(fetchAllGroupsCreator()),
    ]);
}

function* watchSaveSingleGroup() {
    yield takeEveryWithErrorHandling(ActionTypeNames.SaveSingleGroup, saveSingleGroup);
}

function* createSingleGroup(action: CreateSingleGroupAction) {
    const res = yield call(
        GroupRepository.createGroup,
        action.group,
        action.workspaces
    );
    yield putResolve(savedSingleGroup());
    yield all([
        put(fetchGroupsCreator()),
        put(fetchAllGroupsCreator()),
    ]);
}

function* watchCreateSingleGroup() {
    yield takeEveryWithErrorHandling(ActionTypeNames.CreateSingleGroup, createSingleGroup);
}

function* watchDeleteGroups() {
    yield takeEveryWithErrorHandling(ActionTypeNames.DeleteGroups, deleteGroups);
}

function* deleteGroups(action: DeleteGroupsAction) {
    yield call(GroupRepository.deleteGroups, action.groupIds);
    yield put(unselectAll('groups',action.groupIds)) ;        
    yield putResolve(fetchGroupsCreator());
}

function* watchAssignGroupsWorkspace() {
    yield takeEveryWithErrorHandling(ActionTypeNames.AssignGroupsWorkspaces, assignGroupsWorkspace);
}

function* assignGroupsWorkspace(action: AssignGroupsWorkspacesAction) {
    yield call(GroupRepository.assignGroupsWorkspace, action.groupIds, action.workspaceIds);
    yield putResolve(fetchGroupsCreator());
}

export default [watchFetchTableGroupsNoSearch,watchFetchTableGroups, watchFetchAllGroups,
    watchDeleteGroups, watchAssignGroupsWorkspace, watchCopySingleGroup, watchFetchGroupsPerWorkspace,
    watchFetchSingleGroup, watchSaveSingleGroup, watchCreateSingleGroup, watchNewSingleGroup];